<template>
  <div class="container save-to-database">
    <div class="row">
      <div class="col-sm-12">
        <div class="title-wrapper">
          <h1 class="title">Save to our database</h1>
        </div>
        <div class="title-divider"></div>
        <a @click.prevent="$router.back()" class="back-button" href="#">
          <svg
            class="bi bi-arrow-left"
            width="1em"
            height="1em"
            viewBox="0 0 16 16"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M5.854 4.646a.5.5 0 0 1 0 .708L3.207 8l2.647 2.646a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 0 1 .708 0z"
            />
            <path
              fill-rule="evenodd"
              d="M2.5 8a.5.5 0 0 1 .5-.5h10.5a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg
          >
          Back</a>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="description-wrapper">
          <p>
            If you want to save your results to our database to be able to
            re-test your hearing. All the data will be securely stored and
            available to you at any time to load it and analyze it. Please
            create your account. If you are previously registered in
            <a href="">Fennex By SmartHear</a> application, please enter your
            existing account credentials.
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
        <div class="form-wrapper">
          <form ref="form" class="needs-validation" novalidate>
            <div class="form-row">
              <input
                v-model="email"
                type="email"
                class="form-control"
                id="email"
                placeholder="E-mail"
                required
              />
              <div class="invalid-feedback">
                Please enter a valid e-mail address
              </div>
            </div>
            <div class="form-row">
              <input
                v-model="password"
                type="password"
                class="form-control"
                id="password"
                placeholder="Password"
                required
                minlength="6"
              />
              <div class="invalid-feedback">
                Please enter your password, minimum 6 characters
              </div>
            </div>
            <div class="button-wrapper">
              <button
                @click.prevent="confirm()"
                class="btn button-main"
                type="submit"
              >
                Confirm
              </button>
              <router-link class="button-minor" to="/successful">Skip</router-link>
            </div>
            <div v-show="showAlert" class="alert alert-danger" role="alert">
              {{ alertText }}
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {auth, usersCollection} from "../store/firebaseConfig";

  export default {
    data() {
      return {
        email: "",
        password: "",
        showAlert: false,
        alertText: "Something went wrong",
      };
    },
    methods: {
      async confirm() {
        this.$refs.form.classList.add("was-validated")
        if (this.$refs.form.checkValidity() === false) return

        let user = await this.getUserOrRegister();

        this.$store.commit("setDBUser", {
          email: this.email,
          password: this.password
        });

        try {
          let data = {
            htLeft: this.$store.state.originalResultsL,
            htRight: this.$store.state.originalResultsR,
            gender: this.$store.state.gender,
            age: this.$store.state.age,
            source: this.$store.state.source
          };
          await usersCollection.doc(user.uid).set(data);
          await this.$router.push("/successful");
        } catch (e) {
          console.log(e);
        }
      },
      async getUserOrRegister() {
        this.showAlert = false
        this.alertText = "Something went wrong"

        let user = {};
        try {
          user = (
            await auth.signInWithEmailAndPassword(this.email, this.password)
          ).user;
        } catch (e) {
          try {
            if (e.code === "auth/user-not-found") {
              user = await auth.createUserWithEmailAndPassword(
                this.email,
                this.password
              ).user;
            }
          } catch (e) {
            this.alertText = e.message
            this.showAlert = true
            console.log(e)
          }
          console.log(e)
          this.alertText = e.message
          this.showAlert = true
        }

        return user;
      }
    }
  };
</script>
